import { BillingIntentions } from "@constants/choices";
import Spinner from "@legacy/core/components/Spinner";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import PriceField from "../../core/fields/PriceField";
import { formatCurrencyForServiceCompany, getCurrencySymbolForServiceCompany } from "../../core/utils/utils";
import { calculateInvoiceAmounts } from "../utils/utils";


class InvoiceApplyBalanceForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const {requestAction, switchToPrimaryForm, submitting, errors} = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="primary" text="Apply" handler={event => requestAction("APPLY_BALANCE")} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const {invoice, applyBalanceData, errors, onFormDataChange} = this.props
        const {amountDue} = calculateInvoiceAmounts(invoice)
        const billingClient = invoice.billing_intention === BillingIntentions.DIFFERENT_CLIENT
            ? invoice.billing_client
            : invoice.service_location.external_client
        const creditBalance = parseFloat(billingClient.credit_balance)

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Apply Balance">
                    <div className="data-panel__form" aria-label="Apply Balance Form">
                        <p className="data-panel__form__caption">Please provide the amount of credit to apply to this invoice.</p>
                        <BasicDisplayField
                            fieldName="amount_due"
                            fieldLabel="Amount Due"
                            fieldValue={formatCurrencyForServiceCompany(amountDue, invoice.service_company)}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="billing_client"
                            fieldLabel="Billing Client"
                            fieldValue={billingClient.name}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="credit_balance"
                            fieldLabel="Available Balance"
                            fieldValue={formatCurrencyForServiceCompany(creditBalance, invoice.service_company)}
                        ></BasicDisplayField>
                        <PriceField
                            fieldName="amount"
                            fieldLabel="Amount to Apply"
                            fieldValue={applyBalanceData.amount || ""}
                            fieldOnChange={amount => onFormDataChange("amount", amount)}
                            currencySymbol={getCurrencySymbolForServiceCompany(invoice.service_company)}
                            errors={errors}
                        ></PriceField>
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default InvoiceApplyBalanceForm;
